import { z } from 'zod';

import { PublicSettingsResultSchema } from '@e-origin/contracts';

import { MILLISECONDS_IN_SECOND, MINUTES_IN_HOUR, SECONDS_IN_MINUTE } from '@constants';
import { apiClient } from '@utils';

type PublicSettingsApiResponse = z.infer<typeof PublicSettingsResultSchema>;

const defaultPublicSettings: Partial<PublicSettingsApiResponse> = {
  isForwarder: false,
};

/**
 * Unauthenticated settings subset — safe to fetch before login (e.g. the login-page badge).
 * Never carries credentials/keys; see the authenticated `useSettings` for the full payload.
 */
export const usePublicSettings = () => {
  const result = apiClient.settings.getPublicSettings.useQuery(
    ['public-settings'],
    {},
    {
      queryKey: ['public-settings'],
      staleTime: MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR,
      placeholderData: { body: { data: defaultPublicSettings } } as any,
    },
  );
  return { ...result, data: { ...defaultPublicSettings, ...result.data?.body?.data } as Partial<PublicSettingsApiResponse> };
};
